export class AppLockUserEnabledOptions {
  /**
   * Optional. If true, allow VoiceOver adjustment. Default is false.
   */
  public voiceOver?: boolean;

  /**
   * Optional. If true, allow Zoom adjustment. Default is false.
   */
  public zoom?: boolean;

  /**
   * Optional. If true, allow Invert Colors adjustment. Default is false.
   */
  public invertColors?: boolean;

  /**
   * Optional. If true, allow AssistiveTouch adjustment. Default is false.
   */
  public assistiveTouch?: boolean;
}
